import React from 'react';
import MemoryTrainer from './app/MemoryTrainer';

function App() {
  return (
    <div>
      <MemoryTrainer />
    </div>
  );
}

export default App;
